import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { IoLanguageOutline } from "react-icons/io5";
import {
  THEME2_TOOLBAR_TRIGGER_HOVER_BG_DARK_SURFACE,
  THEME2_TOOLBAR_TRIGGER_HOVER_BG_LIGHT_SURFACE,
  THEME2_TOOLBAR_TRIGGER_HOVER_ICON_DARK_SURFACE,
  THEME2_TOOLBAR_TRIGGER_HOVER_ICON_LIGHT_SURFACE,
} from "./adminNavbarTheme2Appearance";

const LANG_ITEMS = [
  { code: "en", labelKey: "languages.english", flag: "🇺🇸" },
];

const normalizeLangCode = (lang) => (lang || "en").split("-")[0].toLowerCase();

/**
 * Tema 2 üst çubuk: reactstrap Dropdown ile dil seçimi (bildirim tetikleyicisiyle aynı ölçü).
 */
const NavbarLanguageSelector = ({
  lightNavbarSurface = false,
  toolbarIconFontSize,
  toolbarIconColor,
  toolbarIconColorActive,
}) => {
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [triggerHovered, setTriggerHovered] = React.useState(false);
  const [selectedLanguage, setSelectedLanguage] = React.useState("en");

  React.useEffect(() => {
    if (normalizeLangCode(i18n.language) !== "en") {
      i18n.changeLanguage("en");
    }
    setSelectedLanguage("en");
  }, [i18n]);

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setSelectedLanguage(langCode);
    setDropdownOpen(false);
  };

  const hoverBg = lightNavbarSurface
    ? THEME2_TOOLBAR_TRIGGER_HOVER_BG_LIGHT_SURFACE
    : THEME2_TOOLBAR_TRIGGER_HOVER_BG_DARK_SURFACE;
  const triggerBg = triggerHovered
    ? hoverBg
    : lightNavbarSurface
      ? dropdownOpen
        ? "rgba(0, 0, 0, 0.08)"
        : "transparent"
      : dropdownOpen
        ? "rgba(255, 255, 255, 0.15)"
        : "transparent";
  const triggerIconColor = triggerHovered
    ? lightNavbarSurface
      ? THEME2_TOOLBAR_TRIGGER_HOVER_ICON_LIGHT_SURFACE
      : THEME2_TOOLBAR_TRIGGER_HOVER_ICON_DARK_SURFACE
    : toolbarIconColor != null
      ? dropdownOpen
        ? toolbarIconColorActive ?? "#1d8cf8"
        : toolbarIconColor
      : dropdownOpen
        ? "#1d8cf8"
        : lightNavbarSurface
          ? "rgba(0, 0, 0, 0.55)"
          : "white";

  const menuClassName = lightNavbarSurface
    ? "py-0 shadow-sm dtiq-navbar-lang-menu--light"
    : "py-0 dtiq-navbar-lang-menu--dark";

  return (
    <div className="settings dtiq-navbar-lang-dropdown-root" style={{ position: "relative" }}>
      <Dropdown
        inNavbar
        isOpen={dropdownOpen}
        toggle={() => setDropdownOpen((v) => !v)}
        direction="down"
      >
        <DropdownToggle
          caret={false}
          tag="div"
          role="button"
          tabIndex={0}
          aria-label={t("navbar.language")}
          title={`${t("navbar.language")} (${selectedLanguage.substring(0, 2).toUpperCase()})`}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setDropdownOpen((v) => !v);
            }
          }}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "40px",
            height: "40px",
            backgroundColor: triggerBg,
            transition: "all 0.2s ease",
          }}
          onMouseEnter={() => setTriggerHovered(true)}
          onMouseLeave={() => setTriggerHovered(false)}
        >
          <IoLanguageOutline
            style={{
              fontSize: toolbarIconFontSize ?? "1.5rem",
              color: triggerIconColor,
              ...(!lightNavbarSurface &&
              toolbarIconColor != null &&
              dropdownOpen
                ? { strokeWidth: 2.25 }
                : {}),
            }}
          />
        </DropdownToggle>
        <DropdownMenu
          right
          className={menuClassName}
          style={{
            minWidth: "150px",
            width: "180px",
            paddingLeft:0,
            paddingRight:0
          }}
        >
          {LANG_ITEMS.map((item, idx) => {
            const isSelected = normalizeLangCode(selectedLanguage) === item.code;
            return (
            <DropdownItem
              key={item.code}
              className={isSelected ? "dtiq-navbar-lang-item--selected" : undefined}
              style={{
                borderBottom:
                  idx < LANG_ITEMS.length - 1
                    ? lightNavbarSurface
                      ? "1px solid #e9ecef"
                      : "1px solid rgba(255,255,255,0.08)"
                    : "none",
              }}
              onClick={() => changeLanguage(item.code)}
            >
              <span className="dtiq-navbar-lang-item-row">
                <span className="dtiq-navbar-lang-item-flag" aria-hidden>
                  {item.flag}
                </span>
                <span className="dtiq-navbar-lang-item-label">{t(item.labelKey)}</span>
              </span>
            </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default NavbarLanguageSelector;
